import { api } from './client'
import type { DealHealthKey } from '@/lib/dealHealth'

export type FocusPriority = 'critical' | 'high' | 'medium'

/** One reason a deal is in Focus, and what it adds to the score — "+40 Next contact 74 days overdue". */
export interface FocusFactor {
  points: number
  reason: string
}

export interface FocusContact {
  id: string
  name: string
  phone: string | null
  email: string | null
}

export interface FocusDeal {
  dealId: string
  title: string
  value: number | null
  ownerName: string | null
  stageName: string | null
  priority: FocusPriority
  score: number
  /** Biggest first; they add up to `score`. */
  factors: FocusFactor[]
  /** The deal's follow-up health — the same state its card's badge shows. */
  health: DealHealthKey
  nextContactDate: string | null
  lastContactedAt: string | null
  openTaskCount: number
  /** The primary contact, for a one-tap call or email; null when the deal has none. */
  contact: FocusContact | null
}

export interface Focus {
  summary: { critical: number; high: number; medium: number }
  /** People the caller may narrow to — just themselves for most agents. */
  owners: { id: string; name: string }[]
  /** Deals in Focus in total; `deals` is capped. */
  total: number
  deals: FocusDeal[]
}

export async function getFocus(ownerId?: string | null): Promise<Focus> {
  const { data } = await api.get<Focus>('/api/attention', {
    params: { ownerId: ownerId || undefined },
  })
  return data
}
